export type IconName =
  | 'grid' | 'table' | 'coins' | 'factory' | 'building' | 'inbox' | 'gear'
  | 'upload' | 'calendar' | 'cal' | 'chevron' | 'alert' | 'compare' | 'check'
  | 'close' | 'plus' | 'doc' | 'sun' | 'moon' | 'monitor' | 'logout' | 'source'
  | 'lock' | 'plug' | 'users'
  // Operational Control
  | 'clipboard' | 'truck' | 'scan';

const PATHS: Record<IconName, string[]> = {
  grid: ['M4 4h7v7H4z', 'M13 4h7v7h-7z', 'M4 13h7v7H4z', 'M13 13h7v7h-7z'],
  table: ['M4 5h16v14H4z', 'M4 10h16', 'M4 15h16', 'M10 5v14'],
  coins: ['M4 7h16v3H4z', 'M4 7v10h16V10', 'M4 12h16', 'M4 15h16'],
  factory: ['M3 21V10l5 3V10l5 3V6l6 4v11z', 'M3 21h18'],
  building: ['M5 21V4h9v17', 'M14 9h5v12', 'M8 8h2M8 12h2M8 16h2', 'M4 21h16'],
  inbox: ['M4 13l2-8h12l2 8', 'M4 13v6h16v-6', 'M4 13h4l1 2h6l1-2h4'],
  gear: [
    'M12 15a3 3 0 100-6 3 3 0 000 6z',
    'M19 12a7 7 0 00-.1-1l2-1.6-2-3.4-2.4 1a7 7 0 00-1.7-1l-.4-2.6H10l-.4 2.6a7 7 0 00-1.7 1l-2.4-1-2 3.4 2 1.6a7 7 0 000 2l-2 1.6 2 3.4 2.4-1a7 7 0 001.7 1l.4 2.6h4l.4-2.6a7 7 0 001.7-1l2.4 1 2-3.4-2-1.6a7 7 0 00.1-1z',
  ],
  upload: ['M12 15V4', 'M8 8l4-4 4 4', 'M4 17v3h16v-3'],
  calendar: ['M4 6h16v14H4z', 'M4 10h16', 'M8 3v4M16 3v4'],
  cal: ['M4 6h16v14H4z', 'M4 10h16', 'M8 3v4M16 3v4'],
  chevron: ['M6 9l6 6 6-6'],
  alert: ['M12 3l9 16H3z', 'M12 10v4', 'M12 17h.01'],
  compare: ['M4 7h7M4 12h7M4 17h7', 'M20 7h-4M20 12h-4M20 17h-4', 'M13 4v16'],
  check: ['M5 12l4 4 10-10'],
  close: ['M6 6l12 12M18 6L6 18'],
  plus: ['M12 5v14M5 12h14'],
  doc: ['M6 3h8l4 4v14H6z', 'M14 3v4h4', 'M9 12h6M9 16h6'],
  sun: ['M12 17a5 5 0 100-10 5 5 0 000 10z', 'M12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4'],
  moon: ['M21 12.8A9 9 0 1111.2 3a7 7 0 009.8 9.8z'],
  monitor: ['M3 4h18v12H3z', 'M8 20h8', 'M12 16v4'],
  logout: ['M15 12H4', 'M8 8l-4 4 4 4', 'M10 4h9v16h-9'],
  source: ['M4 6h16v12H4z', 'M4 10h16', 'M7 14h5'],
  lock: ['M6 11h12v9H6z', 'M9 11V8a3 3 0 016 0v3'],
  plug: ['M9 3v6M15 3v6', 'M7 9h10v3a5 5 0 01-10 0z', 'M12 17v4'],
  users: [
    'M9 11a3.5 3.5 0 100-7 3.5 3.5 0 000 7z',
    'M2 20a7 7 0 0114 0',
    'M16 5.2a3.5 3.5 0 010 6.6',
    'M18 20a6 6 0 00-2-4.5',
  ],
  // Инвентаризация — a clipboard with ticked lines.
  clipboard: ['M6 4h12v17H6z', 'M9 4V2.5h6V4', 'M9 10l1.5 1.5L13 9', 'M9 15h6'],
  // Поставщики и долги — a delivery van.
  truck: ['M2 7h11v9H2z', 'M13 10h4l3 3v3h-7', 'M6 19a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6z', 'M17 19a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6z'],
  // Документы / OCR — a page under a scanning line.
  scan: ['M4 7V4h3M20 7V4h-3M4 17v3h3M20 17v3h-3', 'M4 12h16'],
};

interface IconProps {
  name: IconName;
  size?: number;
  color?: string;
  strokeWidth?: number;
}

export function Icon({ name, size = 16, color = 'currentColor', strokeWidth = 1.9 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {PATHS[name].map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}
